import mitt, { Emitter } from 'mitt';

type Events = {
  node_detected: string;
  signalrConnectionDead: boolean;
  connectedChange: boolean;
  'sync ends': unknown;
  'sync sensitive data ends': unknown;
  'permission denied': unknown;
  localeChange: string;
  orderExitConfirm: () => void;
  websocketInitialized: boolean;
  'device not registered': boolean;
  networkSpeed: { latency: number; mbps: number };
  qr_order_received: { uid: string; table_label?: string; call_num?: string };
};
export const eventBus: Emitter<Events> = mitt<Events>();
